import {
  getFirestore,
  connectFirestoreEmulator,
  type Firestore,
} from 'firebase/firestore'
import { getFirebaseApp } from './app'
import { useEmulator } from '@/config/env'

let db: Firestore | null = null

export function getDb(): Firestore {
  if (!db) {
    db = getFirestore(getFirebaseApp())
    if (useEmulator) {
      connectFirestoreEmulator(db, '127.0.0.1', 8081)
    }
  }
  return db
}
